<script setup lang="ts">
import TimelineScorecard from '../TimelineScorecard.vue'
import { useExpenses } from '../../store/useExpenses'
import { useI18n } from 'vue-i18n'
import FormExpense from '../FormExpense.vue'
import { computed, ref } from 'vue'
import { useTimers } from '../../store/timers'
import { storeToRefs } from 'pinia'
const props = withDefaults(
  defineProps<{
    date: Date
  }>(),
  {
    date: () => new Date(),
  }
)

// const { getTodaysExpenses, getTodaysExpensesTotals } = storeToRefs(useExpenses())
const { isLocked } = storeToRefs(useTimers())
const { getExpensesByDate, getExpenseTotals } = useExpenses()
const { t } = useI18n({ useScope: 'global' })
const timelineLabel = (key: string) => t(`timeline.${key}`)
//Expenses
const expenseModal = ref(false)
const openExpenseModal = () => {
  if (!isLocked.value) {
    expenseModal.value = true
  }
}

const getDaysExpenses = computed(() => {
  return getExpensesByDate(props.date)
})
const getDaysExpenseTotals = computed(() => {
  return getExpenseTotals(getDaysExpenses.value)
})
</script>
<template>
  <TimelineScorecard
    @click="openExpenseModal"
    :header="timelineLabel('expenses')"
    :subheader="`${getDaysExpenseTotals}`"
  />
  <q-dialog v-model="expenseModal">
    <q-card style="min-width: 280px" class="q-pa-md">
      <q-card-section>
        <div class="text-h6">
          <!-- Label -->
          {{ timelineLabel('expenses') }}
        </div>
      </q-card-section>

      <FormExpense :expenses="getDaysExpenses" :date="date"></FormExpense>
    </q-card>
  </q-dialog>
</template>
